import { Col, Row } from 'antd';
import { Common } from '@stockbit/ui';
import { BaseModalProps } from 'global/Modal/BaseModal';
import { BackButton, BaseOtpLimitModal, ModalIllustration } from './styled';

interface ModalOtpLimitProps extends BaseModalProps {
  title?: string;
  description?: string;
  buttonText?: string;
  onBackClick?(): void;
}

const { Text } = Common;

const ModalOtpLimit = ({
  title = 'Coba Lagi Setelah 1 Jam',
  description = 'Kamu telah mencapai limit pengiriman kode OTP sebanyak 5 kali.',
  buttonText = 'Oke',
  onBackClick = () => {},
  ...props
}: ModalOtpLimitProps) => (
  <BaseOtpLimitModal width={450} onCancel={onBackClick} hideHeader {...props}>
    <Row justify="center" gutter={[0, 24]}>
      <Col>
        <Row align="middle" justify="center">
          <Col>
            <ModalIllustration src="/images/phone-otp-timer.svg" />
          </Col>
        </Row>
      </Col>

      <Col>
        <Row align="middle" justify="center" gutter={[0, 16]}>
          <Col span={24}>
            <Text
              align="center"
              weight="700"
              size="24px"
              height="32px"
              color="#333333"
            >
              {title}
            </Text>
          </Col>
          <Col span={24}>
            <Text align="center" size="16px" height="22px" color="#858585">
              {description}
            </Text>
          </Col>
        </Row>
      </Col>

      <Col span={24}>
        <BackButton type="primary" onClick={onBackClick}>
          {buttonText}
        </BackButton>
      </Col>
    </Row>
  </BaseOtpLimitModal>
);

export default ModalOtpLimit;
